import { render, staticRenderFns } from "./help-modal.vue?vue&type=template&id=708201ab"
import script from "./help-modal.vue?vue&type=script&lang=js"
export * from "./help-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports